import { AppState } from 'Store'

const getFiles = (state: AppState) => state.modules.files.files
const getFilesBlob = (state: AppState) => state.modules.files.fileBlobs
const getRequestedFiles = (state: AppState) => state.modules.files.requestedFiles
const getFileContainersMap = (state: AppState) => state.modules.files.fileContainersMap

export const fileSelectors = {
	getFiles,
	getFilesBlob,
	getRequestedFiles,
	getFileContainersMap,
}
